import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IntegrationCardHeaderProps {
  integrationName: string;
  logoUrl: string;
  totalEvents: number;
}

export const IntegrationCardHeader: React.FC<IntegrationCardHeaderProps> = ({
  integrationName,
  logoUrl,
  totalEvents,
}) => {
  const { t } = useTranslation('reports');
  const [imageError, setImageError] = useState(false);

  return (
    <div className="flex items-center gap-4 mb-3">
      <div className="flex size-10 items-center justify-center rounded-lg bg-muted p-2">
        {imageError ? (
          <div className="text-sm font-medium">{integrationName.slice(0, 2).toUpperCase()}</div>
        ) : (
          <img
            src={logoUrl}
            alt={t('integration.logoAlt', { name: integrationName })}
            className="size-full object-contain"
            onError={() => setImageError(true)}
          />
        )}
      </div>
      <h3 className="text-lg font-semibold">{integrationName}</h3>
      <span className="ml-auto text-sm text-muted-foreground">
        {t('integration.events', { count: totalEvents })}
      </span>
    </div>
  );
};
